var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox, MediaPlayer, Modal, ModalBody, ModalHead, Spinner, } from '@dixa/lib-shared-habla';
import { config } from 'lib-shared-backend-config';
import { useEffect, useState } from 'react';
import { createAuthorizationHeaderValue } from 'utils/apis/axios/axiosBaseQuery';
import styles from '../style/video-lightbox.module.scss';
function isPrivate(url) {
    return url.includes(`${config.url.files}/private`);
}
export default function VideoLightbox({ url, fileName, className, onClose, }) {
    console.log(url, fileName);
    const [videoType, setVideoType] = useState('');
    const [loadingStatus, setLoadingStatus] = useState('succeeded');
    const fetchFileBlob = (url) => __awaiter(this, void 0, void 0, function* () {
        const basicAuth = yield createAuthorizationHeaderValue();
        return new Promise((resolve, reject) => {
            if (!url) {
                console.log('URL WAS NULL!');
                reject();
            }
            const headers = new Headers();
            if (isPrivate(url)) {
                headers.append('Authorization', basicAuth);
            }
            const request = {
                method: 'GET',
                headers,
                mode: 'cors',
                cache: 'no-cache',
            };
            fetch(url, request)
                .then((response) => {
                for (const pair of response.headers.entries()) {
                    console.log(pair);
                    if (pair[0] === 'content-type') {
                        setVideoType(pair[1]);
                        break;
                    }
                }
                return response.blob();
            })
                .then((blob) => {
                resolve(blob);
            })
                .catch((e) => {
                console.log('Error', e);
                reject(e);
            });
        });
    });
    useEffect(() => {
        loadPreview(url);
    }, [url]);
    const loadPreview = (url) => {
        setVideoType('');
        setLoadingStatus('loading');
        try {
            fetchFileBlob(url)
                .then((blob) => {
                setLoadingStatus('succeeded');
            })
                .catch((e) => {
                console.error('ERROR fetchFileBlob', e);
                setLoadingStatus('failed');
                setVideoType('');
            });
        }
        catch (e) {
            console.log('Error', e);
        }
    };
    return (_jsxs(Modal, Object.assign({ isOpen: videoType !== '' || loadingStatus === 'loading', allowClickOutside: true, allowEscClose: true, className: className, onClose: onClose }, { children: [_jsx(ModalHead, { title: fileName, onClose: onClose }), _jsxs(ModalBody, Object.assign({ className: styles.xlsxLightbox }, { children: [_jsx(FlexBox, Object.assign({ justifyContent: "center" }, { children: loadingStatus === 'loading' && _jsx(Spinner, { size: 32 }) })), _jsx(FlexBox, Object.assign({ justifyContent: "center" }, { children: _jsx(MediaPlayer, { className: styles.videoLightbox, mediaFile: { src: url, type: videoType }, isPrivateFile: isPrivate(url) }) }))] }))] })));
}
